import styles from '@styles/components/mobile/PresenteeismTable/Asistencia.module.css';

const Asistencia = ({colaborador, fecha, edificio, entrada, salida, estado, estadoColor}) => {

    const renderCorrectStatusStyles = (status) => {
        switch(status) {
            case 'green':
                return {color: "#56A725", background: "rgba(86, 167, 37, 0.10)"}
            case 'gray':
                return {color: "#6C778B", background: "rgba(108, 119, 139, 0.10)"}
            case 'yellow':
                return {color: "#EEA821", background: "rgba(238, 168, 33, 0.10)"}
            case 'red':
                return {color: "#FF5454", background: "rgba(255, 84, 84, 0.10)"}
        }
    }

    const renderColaboradorName = (colaborador) => {
        let nombres = colaborador.split(' ');
        const lastName = nombres.pop();
      
        return (
          <>
            <p>
              {nombres.join(' ')}
            </p>
            <span>{lastName}</span>
          </>
        );
      };

    return (
        <div className={styles['main-container']}>
            <div className={styles['name-container']}>
                {renderColaboradorName(colaborador)}
            </div>
            <div className={styles['info-container']}>
                <div className={styles['times-container']}>
                    <p>{fecha}</p>
                    <p>{entrada ? entrada : 'N/A'}</p>
                    <p>{salida ? salida : 'N/A'}</p>

                </div>
                <div className={styles['building-container']}>
                    <div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.06355 0.0361812C2.96774 0.004049 2.86613 -0.00686814 2.76572 0.00417946C2.66531 0.0152271 2.56847 0.0479777 2.48185 0.100182L1.03985 0.969473C0.936196 1.03196 0.850414 1.12035 0.790858 1.22604C0.731301 1.33173 0.699999 1.45111 0.7 1.57256V6.29669H0.35C0.257174 6.29669 0.16815 6.33374 0.102513 6.39969C0.0368749 6.46564 0 6.55508 0 6.64835C0 6.74161 0.0368749 6.83106 0.102513 6.897C0.16815 6.96295 0.257174 7 0.35 7H6.65C6.74283 7 6.83185 6.96295 6.89749 6.897C6.96313 6.83106 7 6.74161 7 6.64835C7 6.55508 6.96313 6.46564 6.89749 6.39969C6.83185 6.33374 6.74283 6.29669 6.65 6.29669H6.3V1.62672C6.29991 1.47921 6.25367 1.33546 6.16781 1.21581C6.08195 1.09616 5.96081 1.00666 5.82155 0.959978L3.06355 0.0361812ZM5.6 6.29669V1.62672L3.15 0.806657V6.29669H5.6ZM2.45 0.939582L1.4 1.57256V6.29669H2.45V0.939582Z" fill="#344054"/>
                    </svg>
                        <p>{edificio}</p>
                    </div>
                </div>                
            </div>
            <div className={styles['status-container']} >
                <div style={renderCorrectStatusStyles(estado)}>
                    Completo
                </div>
            </div>
        </div>
    );
}

export default Asistencia;